import { ApplicationConfig, importProvidersFrom, provideExperimentalZonelessChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideNativeDateAdapter } from "@angular/material/core";
import { HammerModule } from "@angular/platform-browser";
import { LayoutModule } from "@angular/cdk/layout";
import { ServiceWorkerModule } from "@angular/service-worker";
import { MqttModule, IMqttServiceOptions } from "ngx-mqtt";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";

import { environment as env } from "../environments/environment";
import { routes } from "./app.routes";
import { UserService } from "./_services/user.service";
import { ShedService } from "./_services/mqtt/shed.service";

const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: env.mqtt.hostname,
  port: env.mqtt.port,
  password: env.mqtt.password,
  path: env.mqtt.path,
  protocol: env.mqtt.protocol === "wss" ? "wss" : "ws",
  username: env.mqtt.username,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideNativeDateAdapter(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(env.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    importProvidersFrom(
      MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
      ServiceWorkerModule.register("ngsw-worker.js", { enabled: env.production }),
      HammerModule,
      LayoutModule,
    ),
    UserService,
    ShedService,
  ],
};
